<template>
  <Form ref="form">
    <form @submit.prevent="submit">
      <ZDialog :show="isVisible">
        <template #header>
          <h4 class="modal-title">
            Change Password
          </h4>
        </template>
        <template #body>
          <div class="row">
            <p class="ml-2">Please supply a new password for {{ firstName }} {{ lastName }} ({{ username }}):</p>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <ZInput type="password" v-model="password" name="password" label="Password" autocomplete="new-password"
                validate="required" />
              <ZInput type="password" v-model="password2" name="password2" label="Password again"
                autocomplete="new-password" validate="required" />
            </div>
          </div>
        </template>
        <template #footer>
          <button type="button" class="btn btn-light" @click="close()">Cancel</button>
          <button type="submit" class="btn btn-primary ms-1">Change Password</button>
        </template>
      </ZDialog>
    </form>
  </Form>
</template>
<script>
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import { Form } from 'vee-validate'
export default {
  name: 'change-password',
  components: {
    ZDialog,
    ZInput,
    Form
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      password: '',
      password2: '',
      reason: '',
      isLoading: true
    }
  },
  mounted() {
    this.isLoading = false
    let $this = this
    this.password = ''
    this.password2 = ''
    this.reason = ''
    setTimeout(function () {
      $this.password = ''
      $this.password2 = ''
      $this.reason = ''
    }, 400)
  },
  computed: {
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    firstName: {
      get() {
        let _name = ''
        if (this.value !== undefined && this.value !== null) {
          _name = this.value.firstName
        }
        return _name
      }
    },
    lastName: {
      get() {
        let _name = ''
        if (this.value !== undefined && this.value !== null) {
          _name = this.value.lastName
        }
        return _name
      }
    },
    username: {
      get() {
        let _name = ''
        if (this.value !== undefined && this.value !== null) {
          _name = this.value.username
        }
        return _name
      }
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    },
    validatePassword() {
      let valid = true
      this.reason = ''
      if (this.isLoading === false && this.password !== '') {
        if (this.password === this.password2) {
          let strongRegex = new RegExp(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
          )
          valid = strongRegex.test(this.password)
          if (valid === false) {
            this.reason =
              "Password doesn't meet minimum strength of special characters (!@#$%^&*), lower case (a-z), upper case (A-Z) and numbers (0-9), and at least 8 characters in length."
          }
        } else {
          this.reason = "Passwords don't match."
          valid = false
        }
      }
      return valid
    },
    async submit() {
      this.$refs.form.validate().then(async success => {
        if (success.valid) {
          if (this.validatePassword()) {
            let data = {
              contact: parseInt(this.value.contact),
              userid: parseInt(this.value.user),
              password: this.password
            }
            this.$emit('send', data)
          } else {
            alert(this.reason)
          }
        } else {
          alert('Please supply a password.')
        }
      })
    }
  }
}
</script>
